import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { InCallEditor } from './in_call_editor';
import { InCallToolbar } from './in_call_toolbar';
import { MilkdownProvider } from '@milkdown/react';
import { NotesToolbarContextProvider } from '../../context/notes/notes_toolbar_context';
import { EditorStateContextProvider, useEditorStateContext, } from '../../context/notes/notes_editor_state_context';
import { styled, Theme } from '../../styles';
import { Column, Row } from '../layout/flex';
import { SaveUpdateButton } from './save_update_button';
import { EditButton } from './edit_button';
import { milkdownStyles } from './styles';
export function InCallNotes({ defaultTemplate = '', onSave, markdownPersistedToBackend, initialMarkdown, onNoteUpdated, maxCharacters, captureButtonClick, }) {
    return (_jsx(NotesToolbarContextProvider, { children: _jsx(EditorStateContextProvider, { defaultTemplate: defaultTemplate, onSave: onSave, markdownPersistedToBackend: markdownPersistedToBackend, initialMarkdown: initialMarkdown, onNoteUpdated: onNoteUpdated, maxCharacters: maxCharacters, captureButtonClick: captureButtonClick, inCallOrPostCall: "in-call", readOnlyYn: false, children: _jsx(MilkdownProvider, { children: _jsx(InCallNotesView, {}) }) }) }));
}
export function InCallNotesView() {
    const { displayModeYn, currentMarkdownInEditor } = useEditorStateContext();
    const button = displayModeYn ? _jsx(EditButton, { inCallOrPostCall: "in-call" }) : _jsx(SaveUpdateButton, {});
    return (_jsxs(NotesWrapper, { "data-testid": "in-call-notes-wrapper", children: [_jsxs(EditorWrapper, { displayModeYn: displayModeYn, children: [_jsx(InCallToolbar, {}), _jsx(InCallEditor, { defaultValue: currentMarkdownInEditor })] }), _jsx(BottomToolbar, { children: button })] }));
}
const NotesWrapper = styled(Column)({
    width: '100%',
    padding: '.5rem',
    columnGap: '.6125rem',
    backgroundColor: Theme.colors.grey05,
    border: `1px solid ${Theme.colors.grey10}`,
    borderRadius: '.5rem',
    ...milkdownStyles,
});
const EditorWrapper = styled(Column)(({ displayModeYn }) => ({
    backgroundColor: Theme.colors.white,
    border: `1px solid ${Theme.colors.grey10}`,
    borderRadius: '.5rem',
    padding: '0',
    cursor: displayModeYn ? 'not-allowed' : 'inherit',
}));
const BottomToolbar = styled(Row)({
    justifyContent: 'flex-end',
    marginTop: '.6125rem',
    alignItems: 'center',
    height: '2.5rem',
});
//# sourceMappingURL=in_call_notes.js.map